import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { CheckCircle2Icon, XIcon } from "lucide-react";
import { recentBuyers, PRODUCT_IMAGE } from "../data/content";
type Notice = {
  name: string;
  country: string;
  minutes: number;
};
export function PurchasePopup() {
  const [notice, setNotice] = useState<Notice | null>(null);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let index = Math.floor(Math.random() * recentBuyers.length);
    let hideTimer: number | undefined;
    const show = () => {
      const buyer = recentBuyers[index % recentBuyers.length];
      index += 1 + Math.floor(Math.random() * 3);
      setNotice({
        ...buyer,
        minutes: 1 + Math.floor(Math.random() * 14)
      });
      hideTimer = window.setTimeout(() => setNotice(null), 5000);
    };
    const first = window.setTimeout(show, 6000);
    const loop = window.setInterval(show, 14000);
    return () => {
      window.clearTimeout(first);
      window.clearInterval(loop);
      if (hideTimer) window.clearTimeout(hideTimer);
    };
  }, [dismissed]);
  return <div className="pointer-events-none fixed bottom-24 left-3 right-3 z-50 sm:bottom-6 sm:left-6 sm:right-auto" aria-live="polite" data-id="element-43" data-mp="116cyzt2ybpaw">
      <AnimatePresence data-id="element-44" data-mp="1awpjjlarnih1">
        {notice && !dismissed && <motion.div key={`${notice.name}-${notice.minutes}`} initial={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} transition={{
        duration: 0.22,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto relative flex w-full items-center gap-3 rounded-2xl bg-white p-3 pr-9 shadow-[0_16px_40px_-12px_rgba(20,33,30,0.35)] ring-1 ring-ink/10 sm:w-[360px]" data-id="element-45" data-mp="1ax7mt1vuiwyg">
            <img src={PRODUCT_IMAGE} alt="" className="h-14 w-14 shrink-0 rounded-xl bg-cream object-contain" data-id="element-46" data-mp="28mki1vgffz8n" />
            <div className="min-w-0" data-id="element-47" data-mp="23npnxxd0eo98">
              <p className="text-[14px] leading-snug text-ink" data-id="element-48" data-mp="2apcr8yu90zhe">
                <strong data-id="element-49" data-mp="2aqxoiw7y6wiy">{notice.name}</strong> from <strong data-id="element-50" data-mp="2fmv1csk05kqz">{notice.country}</strong> just purchased the Biomagnetism Protocol Vault™
              </p>
              <p className="mt-1 flex items-center gap-1 text-[12px] font-medium text-cta" data-id="element-51" data-mp="2ko2aow1smrzr">
                <CheckCircle2Icon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-52" data-mp="2pksr5khifplp" /> Verified purchase · {notice.minutes} min ago
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} className="absolute right-2 top-2 rounded-full p-1 text-muted hover:bg-cream" aria-label="Dismiss notification" data-id="element-53" data-mp="1wx6b3cr3ishy">
              <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-54" data-mp="26nrhvngxb3by" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}